/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { pixelsToUnit, unitToPixels } from 'shared/libs/utils/numbers';
import ExpandableContent from 'shared/ui/components/ExpandableContent.vue';
import InputWithUnit from 'shared/ui/components/form-components/InputWithUnit.vue';

const __vue_script__ = {
    name: 'DimensionControls',

    components: {
        InputWithUnit,
        ExpandableContent,
    },

    props: {
        width: {
            type: Number,
            required: true,
        },

        height: {
            type: Number,
            required: true
        },

        pageDimensions: {
            type: Object,
            required: true,
        },

        uniformScaling: {
            type: Boolean,
            required: false,
            default: false,
        },
    },

    data() {
        return {
            inputWidth: this.toUnit(this.width),
            inputHeight: this.toUnit(this.height),
            currentFocus: null,
        };
    },
    watch: {
        pageDimensions() {
            this.inputWidth = this.toUnit(this.width);
            this.inputHeight = this.toUnit(this.height);
        },
        width(value) {
            if (this.currentFocus !== 'width') {
                this.inputWidth = this.toUnit(value);
            }
        },
        height(value) {
            if (this.currentFocus !== 'height') {
                this.inputHeight = this.toUnit(value);
            }
        }
    },

    methods: {
        /** @param {number} pixels */
        toUnit(pixels) {
            return pixelsToUnit(
                pixels,
                this.pageDimensions.dpi,
                this.pageDimensions.userUnit,
            );
        },
        handleInput(property, units) {
            if (!Number.isFinite(units)) return;
            const value = unitToPixels(
                units,
                this.pageDimensions.dpi,
                this.pageDimensions.userUnit,
            );
            this.$emit('change', { property, value });
        },
        handleFocus(property, event) {
            this.currentFocus = property;
            this.$emit('focus', event);
        },
        handleBlur(property, event) {
            this.currentFocus = null;
            this.$emit('blur', event);
            this.$nextTick(() => {
                if (property === 'width') {
                    this.inputWidth = this.toUnit(this.width);
                    return;
                }
                if (property === 'height') {
                    this.inputHeight = this.toUnit(this.height);
                }
            });
        },
    }
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dimension-controls"},[(_vm.uniformScaling)?_c('div',{staticClass:"param-group"},[_c('input-with-unit',{attrs:{"type":"number","name":"width","value":_vm.inputWidth,"label":_vm.$t('onsite_scanning.badge_editor.parameters.size'),"step":0.25},on:{"input":function($event){return _vm.handleInput('width', $event)},"focus":function($event){return _vm.handleFocus('width', $event)},"blur":function($event){return _vm.handleBlur('width', $event)}}},[_c('span',[_vm._v(_vm._s(_vm.pageDimensions.userUnit))])])],1):_c('div',{staticClass:"param-group"},[_c('input-with-unit',{attrs:{"type":"number","name":"width","value":_vm.inputWidth,"label":_vm.$t('onsite_scanning.badge_editor.parameters.width'),"step":0.25},on:{"input":function($event){return _vm.handleInput('width', $event)},"focus":function($event){return _vm.handleFocus('width', $event)},"blur":function($event){return _vm.handleBlur('width', $event)}}},[_c('span',[_vm._v(_vm._s(_vm.pageDimensions.userUnit))])]),_c('input-with-unit',{attrs:{"type":"number","name":"height","value":_vm.inputHeight,"label":_vm.$t('onsite_scanning.badge_editor.parameters.height'),"step":0.25,"disabled":_vm.uniformScaling},on:{"input":function($event){return _vm.handleInput('height', $event)},"focus":function($event){return _vm.handleFocus('height', $event)},"blur":function($event){return _vm.handleBlur('height', $event)}}},[_c('span',[_vm._v(_vm._s(_vm.pageDimensions.userUnit))])])],1)])}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "DimensionControls.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__